<template>
  <div>
    <common-dialog
      ref="dialog"
      width="700px"
      show-save-button
      unit="商品类别"
      edit-title
      id-key="RecordId"
      :data="data"
      form-label-width="125px"
      :form-rules="rules"
      :save-func="api.oneSave"
      @create-opened="onCreateOpened"
      @edit-opened="onEditOpened"
      close-on-saved
      :before-save="onBeforeSave"
      @closed="onClosed"
      @close-saved="$emit('close-saved')"
    >
      <template slot="form">
        <el-row v-if="loginInfo.UserType == 1">
          <el-col :span="24">
            <el-form-item label="所属门店" prop="StoreId">
              <store-select
                v-model="data.StoreId"
                ref="storeSelect"
              ></store-select>
            </el-form-item>
          </el-col>
        </el-row>
      </template>
    </common-dialog>
  </div>
</template>
  <script>
import editDialogMixin from "@/mixins/editDialog";
import commonDialog from "@/components/common/dialog";
import storeSelect from "@/components/shop/store/select";

export default {
  mixins: [editDialogMixin],
  components: {
    commonDialog,
    storeSelect,
  },
  data() {
    return {
      data: {
        StoreId: JSON.parse(localStorage.getItem("loginInfo")).StoreId,
      },
      list: [],
      api: require("@/api/goods/type").default,
      isMB: this.$store.state.isMB,
      rules: {
        StoreId: [{ required: true, message: "门店不能为空" }],
      },
      loginInfo: JSON.parse(localStorage.getItem("loginInfo")),
    };
  },
  
  methods: {
    onCreateOpened(row) {
     data.StoreId=loginInfo.StoreId
    },
    onEditOpened(data) {
        data.StoreId=loginInfo.StoreId
    },
    onBeforeSave() {},
    onClosed() {},
  },
};
</script>